export default __webpack_public_path__ + "static/media/Coping Mechanisms - Anxiety worksheet.0e5fbd36.pdf";